import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const ServeRequest = z.record(z.string(), z.never())

export type ServeRequest = z.infer<typeof ServeRequest>

export const ServeResponse = z.unknown()

export type ServeResponse = z.infer<typeof ServeResponse>

export const serveDeclaration = endpointDeclaration(ServeRequest, ServeResponse)
